var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNAutorizado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#002f52",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 241",
    enableBackground: "new 0 0 256 241",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254,188V2H2v186h111v29H75v22h106v-22h-38v-29H254z M19,19h217v151H19L19,19z M164.721,82.158v67.785H91.279V82.158h8.956 V66.225c0-15.556,12.727-28.283,28.283-28.283s28.283,12.727,28.283,28.283v15.933L164.721,82.158z M134.175,119.68 c3.111-1.98,5.091-5.374,5.091-9.333c0-6.222-5.091-11.313-11.313-11.313s-11.313,5.091-11.313,11.313 c0,3.96,1.98,7.354,5.091,9.333l-2.263,13.293h16.97L134.175,119.68z M145.582,66.225c0-9.333-7.636-16.97-16.97-16.97 s-16.97,7.636-16.97,16.97v15.933h27.623h6.316V66.225z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNAutorizado);
export default __webpack_public_path__ + "static/media/nAutorizado.abd2c8cf2142942dd29bb4590ef60682.svg";
export { ForwardRef as ReactComponent };